export const Slices = {
    Search: 'search',
} as const;
